import React, { useEffect, useState } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, IconButton } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";

export default function GroupViewDialog({ open, onClose, groupId, getGroup }) {
    const [group, setGroup] = useState(null);

    useEffect(() => {
        if (open && groupId) {
            (async () => {
                try {
                    const res = await getGroup(groupId);
                    const data = res?.data || res;
                    const g = data?.data || data;
                    setGroup(g);
                } catch (e) {
                    console.error("fetch group failed", e);
                    setGroup(null);
                }
            })();
        }
    }, [open, groupId, getGroup]);

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>
                檢視群組
                <IconButton aria-label="close" onClick={onClose} style={{ position: "absolute", right: 8, top: 8 }}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers>
                {group ? (
                    <>
                        <Typography variant="subtitle1" style={{ fontWeight: "bold" }}>群組名稱</Typography>
                        <Typography style={{ marginBottom: 12 }}>{group.group_name || group.windcontract_group_name || "-"}</Typography>

                        <Typography variant="subtitle1" style={{ fontWeight: "bold" }}>備註</Typography>
                        <Typography>{group.note || "-"}</Typography>
                    </>
                ) : (
                    <Typography color="textSecondary">載入中或無資料</Typography>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>關閉</Button>
            </DialogActions>
        </Dialog>
    );
}
